import * as yup from "yup";

export const AlertsValidation = yup.object().shape({
    title: yup.string().required("Alert title is required").max(255, "Title must not exceed 255 characters").trim(),

    content: yup
        .string()
        .required("Alert content is required")
        .min(10, "Content must be at least 10 characters")
        .trim(),

    target_type: yup
        .string()
        .required("Please select target type")
        .oneOf(["all", "roles", "users"], "Invalid target type"),

    target_roles: yup.array().when("target_type", {
        is: "roles",
        then: (schema) => schema.min(1, "Please select at least one role").required("Please select at least one role"),
        otherwise: (schema) => schema.nullable().optional(),
    }),

    target_users: yup.array().when("target_type", {
        is: "users",
        then: (schema) => schema.min(1, "Please select at least one user").required("Please select at least one user"),
        otherwise: (schema) => schema.nullable().optional(),
    }),

    expiry_date: yup
        .date()
        .required("Expiry date is required")
        .test("not-past", "Expiry date cannot be in the past", function (value) {
            if (!value) return true; // Let required validation handle empty values
            const today = new Date();
            today.setHours(0, 0, 0, 0); // Reset time to start of day
            return new Date(value) >= today;
        }),

    is_active: yup.boolean().default(true),
});
